/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { importProviderSetting } from '../models/importProviderSetting';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ImportProviderSettingsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count importProviderSettings
   * Count importProviderSettings (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of importProviderSetting documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServicesecurityImportProviderSettingsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/importProviderSettings/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one importProviderSetting
   * Find one importProviderSetting by its unique identifier.
   * @param identifier importProviderSetting unique identifier
   * @returns any One importProviderSetting document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServicesecurityImportProviderSettings(
    identifier: string,
  ): CancelablePromise<{
    data?: importProviderSetting;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/importProviderSettings/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing importProviderSetting
   * Partially update one existing importProviderSetting
   * @param identifier importProviderSetting unique identifier
   * @param requestBody
   * @returns any updated importProviderSetting. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityImportProviderSettings(
    identifier: string,
    requestBody?: importProviderSetting,
  ): CancelablePromise<{
    data?: importProviderSetting;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/importProviderSettings/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many importProviderSettings
   * Find many importProviderSettings (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many importProviderSetting documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServicesecurityImportProviderSettings1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<importProviderSetting>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/importProviderSettings',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple importProviderSettings
   * Create one or multiple importProviderSettings
   * @param requestBody
   * @returns any One or many importProviderSetting documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServicesecurityImportProviderSettings(
    requestBody?: (importProviderSetting | Array<importProviderSetting>),
  ): CancelablePromise<{
    data?: (importProviderSetting | Array<importProviderSetting>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/importProviderSettings',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing importProviderSetting
   * Partially update many existing importProviderSetting
   * @param requestBody
   * @returns any importProviderSettings updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityImportProviderSettings1(
    requestBody?: Array<importProviderSetting>,
  ): CancelablePromise<{
    data?: Array<importProviderSetting>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/importProviderSettings',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

}
